import { useContext } from 'react';
import { NotificationContext } from "./NotificationContext.js";
export var useNotificationContext = function () { return useContext(NotificationContext); };
//# sourceMappingURL=useNotificationContext.js.map